import { render, staticRenderFns } from "./TableInfoPerson.vue?vue&type=template&id=f1cfedc8"
import script from "./TableInfoPerson.vue?vue&type=script&lang=js"
export * from "./TableInfoPerson.vue?vue&type=script&lang=js"
import style0 from "./TableInfoPerson.vue?vue&type=style&index=0&id=f1cfedc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports